import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, Observable, Subject, switchMap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GuidParentMeterDataOutDictionaryItem, ParentMeterDataOut } from '../../../../api/api-reference';
import { AssetTypeBadgeComponent } from '../asset-type-badge/asset-type-badge.component';

@Component({
  selector: 'app-parent-meter-dropdown-search',
  standalone: true,
  imports: [FormsModule, HttpClientModule, TranslateModule, CommonModule, AssetTypeBadgeComponent],
  templateUrl: './parent-meter-dropdown-search.component.html',
  styleUrls: ['./parent-meter-dropdown-search.component.scss']
})
export class DropdownSearchComponent implements OnInit, OnChanges {
  searchText: string = '';
  filteredItems: GuidParentMeterDataOutDictionaryItem[] = [];
  isOpen: boolean = false;

  @Input() selected: ParentMeterDataOut | null = null;
  @Input() selectPlaceholder: string = 'Select';
  @Input() placeholder: string = 'SEARCHBY_METERNUMBER_OR_ASSETNAME';
  // @Input() fetchItems!: () => Observable<any[]>;
  @Input() fetchItems!: (search: string) => Observable<GuidParentMeterDataOutDictionaryItem[]>;

  @Input() disabled: boolean = false;
  @Output() selectedItem = new EventEmitter<ParentMeterDataOut | null>();
  private searchSubject = new Subject<string>();

  constructor(
    private toastr: ToastrService,
    private elementRef: ElementRef,
  ) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.closeDropdown();
    }
    if (changes['selected'] && !changes['selected'].firstChange && this.selected?.meterNumber) {
      this.closeDropdown();
    }
  }

  ngOnInit(): void {
    this.searchSubject.pipe(
      debounceTime(500),
      switchMap((term) => this.fetchItems(term))
    ).subscribe({
      next: (response) => {
        this.filteredItems = response ?? [];
      },
      error: (err) => {
        this.toastr.error(err);
      }
    });
  }

  async toggleDropdown(): Promise<void> {
    if (this.disabled) {
      return;
    }

    this.searchText = '';

    this.fetchItems(this.searchText).subscribe({
      next: (response) => {
        this.filteredItems = response ?? [];
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
          this.searchSubject.next('');
        }
      },
      error: (err) => {
        this.toastr.error(err);
      }
    });
  }

  search(value: string): void {
    this.searchText = value;
    this.searchSubject.next(value);
  }

  selectItem(item: GuidParentMeterDataOutDictionaryItem): void {
    this.searchText = '';
    this.selected = item.value!;
    this.filteredItems = [];
    this.isOpen = false;
    this.selectedItem.emit(item.value!);
  }

  clearSelected(event?: MouseEvent): void {
    event?.stopPropagation();
    this.searchText = '';
    this.filteredItems = [];
    this.isOpen = false;
    this.selected = null;
    this.selectedItem.emit(null);
  }

  private closeDropdown(): void {
    this.isOpen = false;
    this.searchText = '';
    this.filteredItems = [];
  }
}
